export enum AnalyticsEventName {
  ARCHIVE_VIEWED = 'ARCHIVE_VIEWED',
}

export interface AnalyticsIdentity {
  anonymousId: string;
  sessionId: string;
}

export interface AnalyticsAttribution {
  referrerHost?: string;
  utmSource?: string;
}

export interface ArchiveViewedEvent extends AnalyticsIdentity, AnalyticsAttribution {
  eventId: string;
  eventName: AnalyticsEventName.ARCHIVE_VIEWED;
  eventVersion: 1;
  occurredAt: string;
  archiveAui: string;
}

export type AnalyticsEvent = ArchiveViewedEvent;

interface CreateArchiveViewedEventParams extends AnalyticsIdentity, AnalyticsAttribution {
  eventId: string;
  occurredAt: string;
  archiveAui: string;
}

export const createArchiveViewedEvent = (
  params: CreateArchiveViewedEventParams,
): ArchiveViewedEvent => ({
  eventId: params.eventId,
  eventName: AnalyticsEventName.ARCHIVE_VIEWED,
  eventVersion: 1,
  occurredAt: params.occurredAt,
  anonymousId: params.anonymousId,
  sessionId: params.sessionId,
  archiveAui: params.archiveAui,
  ...(params.referrerHost ? { referrerHost: params.referrerHost } : {}),
  ...(params.utmSource ? { utmSource: params.utmSource } : {}),
});
